import { cn as r } from "../../../lib/utils.es.js";
import { jsx as t, jsxs as l } from "react/jsx-runtime";
import { CheckIcon as s, ChevronRightIcon as b, CircleIcon as u } from "lucide-react";
import { DropdownMenu as o } from "radix-ui";
var f = (e) => /* @__PURE__ */ t(o.Root, {
  "data-slot": "dropdown-menu",
  ...e
}), c = (e) => /* @__PURE__ */ t(o.Portal, {
  "data-slot": "dropdown-menu-portal",
  ...e
}), w = (e) => /* @__PURE__ */ t(o.Trigger, {
  "data-slot": "dropdown-menu-trigger",
  ...e
}), x = ({ className: e, align: i = "start", sideOffset: n = 4, ...a }) => /* @__PURE__ */ t(c, { children: /* @__PURE__ */ t(o.Content, {
  align: i,
  className: r("lib:data-[side=bottom]:slide-in-from-top-2 lib:data-[side=left]:slide-in-from-right-2 lib:data-[side=right]:slide-in-from-left-2 lib:data-[side=top]:slide-in-from-bottom-2 lib:data-[state=open]:fade-in-0 lib:data-[state=open]:zoom-in-95 lib:data-[state=closed]:fade-out-0 lib:data-[state=closed]:zoom-out-95 lib:z-50 lib:max-h-(--radix-dropdown-menu-content-available-height) lib:min-w-32 lib:origin-(--radix-dropdown-menu-content-transform-origin) lib:overflow-y-auto lib:overflow-x-hidden lib:rounded-lg lib:bg-popover lib:p-1 lib:text-popover-foreground lib:shadow-md lib:ring-1 lib:ring-foreground/10 lib:duration-100 lib:data-[align=end]:min-w-(--radix-dropdown-menu-trigger-width) lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in", e),
  "data-slot": "dropdown-menu-content",
  sideOffset: n,
  ...a
}) }), h = (e) => /* @__PURE__ */ t(o.Group, {
  "data-slot": "dropdown-menu-group",
  ...e
}), D = ({ className: e, inset: i, variant: n = "default", ...a }) => /* @__PURE__ */ t(o.Item, {
  className: r("lib:group/dropdown-menu-item lib:relative lib:flex lib:cursor-pointer lib:select-none lib:items-center lib:gap-1.5 lib:rounded-md lib:px-1.5 lib:py-1 lib:text-sm lib:outline-hidden lib:focus:bg-accent lib:focus:text-accent-foreground lib:not-data-[variant=destructive]:focus:**:text-accent-foreground lib:data-disabled:pointer-events-none lib:data-disabled:cursor-not-allowed lib:data-[inset=true]:pl-7 lib:data-[variant=destructive]:text-destructive lib:data-disabled:opacity-50 lib:data-[variant=destructive]:focus:bg-destructive/10 lib:data-[variant=destructive]:focus:text-destructive dark:lib:data-[variant=destructive]:focus:bg-destructive/20 lib:[&_svg:not([class*='size-'])]:size-4 lib:[&_svg]:pointer-events-none lib:[&_svg]:shrink-0 lib:data-[variant=destructive]:*:[svg]:text-destructive", e),
  "data-inset": i,
  "data-slot": "dropdown-menu-item",
  "data-variant": n,
  ...a
}), M = ({ className: e, children: i, checked: n, inset: a, ...d }) => /* @__PURE__ */ l(o.CheckboxItem, {
  checked: n,
  className: r("lib:relative lib:flex lib:cursor-pointer lib:select-none lib:items-center lib:gap-1.5 lib:rounded-md lib:py-1 lib:pr-8 lib:pl-1.5 lib:text-sm lib:outline-hidden lib:focus:bg-accent lib:focus:text-accent-foreground lib:focus:**:text-accent-foreground lib:data-disabled:pointer-events-none lib:data-disabled:cursor-not-allowed lib:data-[inset=true]:pl-7 lib:data-disabled:opacity-50 lib:[&_svg:not([class*='size-'])]:size-4 lib:[&_svg]:pointer-events-none lib:[&_svg]:shrink-0", e),
  "data-inset": a,
  "data-slot": "dropdown-menu-checkbox-item",
  ...d,
  children: [/* @__PURE__ */ t("span", {
    className: "lib:pointer-events-none lib:absolute lib:right-2 lib:flex lib:items-center lib:justify-center",
    "data-slot": "dropdown-menu-checkbox-item-indicator",
    children: /* @__PURE__ */ t(o.ItemIndicator, { children: /* @__PURE__ */ t(s, {}) })
  }), i]
}), z = (e) => /* @__PURE__ */ t(o.RadioGroup, {
  "data-slot": "dropdown-menu-radio-group",
  ...e
}), I = ({ className: e, children: i, inset: n, ...a }) => /* @__PURE__ */ l(o.RadioItem, {
  className: r("lib:relative lib:flex lib:cursor-pointer lib:select-none lib:items-center lib:gap-1.5 lib:rounded-md lib:py-1 lib:pr-8 lib:pl-1.5 lib:text-sm lib:outline-hidden lib:focus:bg-accent lib:focus:text-accent-foreground lib:focus:**:text-accent-foreground lib:data-disabled:pointer-events-none lib:data-disabled:cursor-not-allowed lib:data-[inset=true]:pl-7 lib:data-disabled:opacity-50 lib:[&_svg:not([class*='size-'])]:size-4 lib:[&_svg]:pointer-events-none lib:[&_svg]:shrink-0", e),
  "data-inset": n,
  "data-slot": "dropdown-menu-radio-item",
  ...a,
  children: [/* @__PURE__ */ t("span", {
    className: "lib:pointer-events-none lib:absolute lib:right-2 lib:flex lib:items-center lib:justify-center",
    "data-slot": "dropdown-menu-radio-item-indicator",
    children: /* @__PURE__ */ t(o.ItemIndicator, { children: /* @__PURE__ */ t(u, { className: "lib:size-2.5 lib:fill-current" }) })
  }), i]
}), N = ({ className: e, inset: i, ...n }) => /* @__PURE__ */ t(o.Label, {
  className: r("lib:px-1.5 lib:py-1 lib:font-medium lib:text-muted-foreground lib:text-xs lib:data-[inset=true]:pl-7", e),
  "data-inset": i,
  "data-slot": "dropdown-menu-label",
  ...n
}), y = ({ className: e, ...i }) => /* @__PURE__ */ t(o.Separator, {
  className: r("lib:pointer-events-none lib:-mx-1 lib:my-1 lib:h-px lib:bg-border", e),
  "data-slot": "dropdown-menu-separator",
  ...i
}), _ = ({ className: e, ...i }) => /* @__PURE__ */ t("span", {
  className: r("lib:ml-auto lib:text-muted-foreground lib:text-xs lib:tracking-widest lib:group-focus/dropdown-menu-item:text-accent-foreground", e),
  "data-slot": "dropdown-menu-shortcut",
  ...i
}), k = (e) => /* @__PURE__ */ t(o.Sub, {
  "data-slot": "dropdown-menu-sub",
  ...e
}), C = ({ className: e, inset: i, children: n, ...a }) => /* @__PURE__ */ l(o.SubTrigger, {
  className: r("lib:flex lib:cursor-pointer lib:select-none lib:items-center lib:gap-1.5 lib:rounded-md lib:px-1.5 lib:py-1 lib:text-sm lib:outline-hidden lib:focus:bg-accent lib:focus:text-accent-foreground lib:not-data-[variant=destructive]:focus:**:text-accent-foreground lib:data-[state=open]:bg-accent lib:data-[inset=true]:pl-7 lib:data-[state=open]:text-accent-foreground lib:[&_svg:not([class*='size-'])]:size-4 lib:[&_svg]:pointer-events-none lib:[&_svg]:shrink-0", e),
  "data-inset": i,
  "data-slot": "dropdown-menu-sub-trigger",
  ...a,
  children: [n, /* @__PURE__ */ t(b, { className: "lib:ml-auto" })]
}), S = ({ className: e, ...i }) => /* @__PURE__ */ t(o.SubContent, {
  className: r("lib:data-[side=bottom]:slide-in-from-top-2 lib:data-[side=left]:slide-in-from-right-2 lib:data-[side=right]:slide-in-from-left-2 lib:data-[side=top]:slide-in-from-bottom-2 lib:data-[state=open]:fade-in-0 lib:data-[state=open]:zoom-in-95 lib:data-[state=closed]:fade-out-0 lib:data-[state=closed]:zoom-out-95 lib:z-50 lib:min-w-24 lib:origin-(--radix-dropdown-menu-content-transform-origin) lib:overflow-hidden lib:rounded-lg lib:bg-popover lib:p-1 lib:text-popover-foreground lib:shadow-lg lib:ring-1 lib:ring-foreground/10 lib:duration-100 lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in", e),
  "data-slot": "dropdown-menu-sub-content",
  ...i
});
export {
  f as DropdownMenu,
  M as DropdownMenuCheckboxItem,
  x as DropdownMenuContent,
  h as DropdownMenuGroup,
  D as DropdownMenuItem,
  N as DropdownMenuLabel,
  c as DropdownMenuPortal,
  z as DropdownMenuRadioGroup,
  I as DropdownMenuRadioItem,
  y as DropdownMenuSeparator,
  _ as DropdownMenuShortcut,
  k as DropdownMenuSub,
  S as DropdownMenuSubContent,
  C as DropdownMenuSubTrigger,
  w as DropdownMenuTrigger
};
